export default "__VITE_ASSET__k3pkp37___"